var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("b-table", {
        attrs: {
          small: "",
          fields: _vm.fields,
          items: _vm.data.qualityControl,
          responsive: "sm",
          striped: "",
        },
        scopedSlots: _vm._u([
          {
            key: "cell(#)",
            fn: function (data) {
              return [_vm._v(" " + _vm._s(data.index + 1) + " ")]
            },
          },
          {
            key: "cell(name)",
            fn: function (data) {
              return [_vm._v(" " + _vm._s(data.value.first) + " ")]
            },
          },
          {
            key: "cell(Popularity)",
            fn: function (data) {
              return [
                _c("b-progress", {
                  attrs: {
                    value: data.value.value,
                    max: "100",
                    variant: data.value.variant,
                    striped: "",
                  },
                }),
              ]
            },
          },
          {
            key: "cell(reading1)",
            fn: function (data) {
              return [
                _c("b-form-input", {
                  attrs: { id: "reading1", type: "number", value: data.value },
                  on: {
                    change: function ($event) {
                      return _vm.readingOneUpdated(data.item.id, $event)
                    },
                  },
                }),
              ]
            },
          },
          {
            key: "cell(reading2)",
            fn: function (data) {
              return [
                _c("b-form-input", {
                  attrs: { id: "reading2", type: "number", value: data.value },
                  on: {
                    change: function ($event) {
                      return _vm.readingTwoUpdated(data.item.id, $event)
                    },
                  },
                }),
              ]
            },
          },
          {
            key: "cell(status)",
            fn: function (data) {
              return [
                _c("b-form-select", {
                  attrs: { options: _vm.optionQC },
                  on: {
                    change: function ($event) {
                      return _vm.readingQc(data.item.id, $event)
                    },
                  },
                  model: {
                    value: data.item.status,
                    callback: function ($$v) {
                      _vm.$set(data.item, "status", $$v)
                    },
                    expression: "data.item.status",
                  },
                }),
              ]
            },
          },
          {
            key: "cell(view_document)",
            fn: function (row) {
              return [
                _c(
                  "b-form-checkbox",
                  {
                    staticClass: "vs-checkbox-con",
                    attrs: { plain: "" },
                    on: { change: row.toggleDetails },
                    model: {
                      value: row.detailsShowing,
                      callback: function ($$v) {
                        _vm.$set(row, "detailsShowing", $$v)
                      },
                      expression: "row.detailsShowing",
                    },
                  },
                  [
                    _c("span", { staticClass: "vs-checkbox" }),
                    _c("span", { staticClass: "vs-label" }, [
                      _vm._v(_vm._s(row.detailsShowing ? "Hide" : "Show")),
                    ]),
                  ]
                ),
              ]
            },
          },
          {
            key: "row-details",
            fn: function (row) {
              return [
                _c(
                  "b-row",
                  { staticClass: "mb-2" },
                  [
                    _c(
                      "b-col",
                      { staticClass: "mb-1", attrs: { md: "3" } },
                      [
                        _c("b-form-file", {
                          ref: "fileInput",
                          staticClass: "d-none",
                          attrs: {
                            placeholder: "Choose a file or drop it here...",
                            "drop-placeholder": "Drop file here...",
                            multiple: "",
                          },
                          on: { change: _vm.handleFileUpload },
                        }),
                        _c(
                          "b-button",
                          {
                            attrs: { variant: "primary" },
                            on: { click: _vm.openFilePicker },
                          },
                          [_vm._v("Upload Document")]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "b-row",
                  [
                    _c(
                      "b-col",
                      { attrs: { md: "3" } },
                      [
                        _c(
                          "b-card",
                          { staticClass: "custom-card mb-5" },
                          [
                            _c(
                              "b-card-header",
                              { staticClass: "justify-content-end px-0" },
                              [
                                _c(
                                  "b-dropdown",
                                  {
                                    staticClass: "chart-dropdown",
                                    attrs: {
                                      variant: "link",
                                      "no-caret": "",
                                      "toggle-class": "p-0",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "button-content",
                                          fn: function () {
                                            return [
                                              _c("feather-icon", {
                                                staticClass:
                                                  "text-body cursor-pointer",
                                                attrs: {
                                                  icon: "MoreVerticalIcon",
                                                  size: "18",
                                                },
                                              }),
                                            ]
                                          },
                                          proxy: true,
                                        },
                                      ],
                                      null,
                                      true
                                    ),
                                  },
                                  [
                                    _c(
                                      "b-dropdown-item",
                                      {
                                        directives: [
                                          {
                                            name: "b-modal",
                                            rawName: "v-b-modal.modal-document",
                                            modifiers: {
                                              "modal-document": true,
                                            },
                                          },
                                        ],
                                      },
                                      [_vm._v(" View ")]
                                    ),
                                    _c(
                                      "b-dropdown-item",
                                      { attrs: { href: "#" } },
                                      [_vm._v(" Download ")]
                                    ),
                                    _c(
                                      "b-dropdown-item",
                                      { attrs: { href: "#" } },
                                      [_vm._v(" Delete ")]
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c(
                              "b-card-body",
                              [
                                _c(
                                  "b-row",
                                  {
                                    staticClass:
                                      "justify-content-center align-items-center",
                                  },
                                  [
                                    _c(
                                      "b-col",
                                      {
                                        staticClass:
                                          "d-flex flex-column justify-content-center align-items-center text-center",
                                        attrs: { md: "6" },
                                      },
                                      [
                                        _c("feather-icon", {
                                          attrs: {
                                            icon: "FolderIcon",
                                            size: "50",
                                          },
                                        }),
                                        _c("b-card-text", [
                                          _vm._v("document1.pdf"),
                                        ]),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "b-col",
                      { attrs: { md: "3" } },
                      [
                        _c(
                          "b-card",
                          { staticClass: "custom-card mb-5" },
                          [
                            _c(
                              "b-card-header",
                              { staticClass: "justify-content-end px-0" },
                              [
                                _c(
                                  "b-dropdown",
                                  {
                                    staticClass: "chart-dropdown",
                                    attrs: {
                                      variant: "link",
                                      "no-caret": "",
                                      "toggle-class": "p-0",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "button-content",
                                          fn: function () {
                                            return [
                                              _c("feather-icon", {
                                                staticClass:
                                                  "text-body cursor-pointer",
                                                attrs: {
                                                  icon: "MoreVerticalIcon",
                                                  size: "18",
                                                },
                                              }),
                                            ]
                                          },
                                          proxy: true,
                                        },
                                      ],
                                      null,
                                      true
                                    ),
                                  },
                                  [
                                    _c(
                                      "b-dropdown-item",
                                      {
                                        directives: [
                                          {
                                            name: "b-modal",
                                            rawName: "v-b-modal.modal-document",
                                            modifiers: {
                                              "modal-document": true,
                                            },
                                          },
                                        ],
                                      },
                                      [_vm._v(" View ")]
                                    ),
                                    _c(
                                      "b-dropdown-item",
                                      { attrs: { href: "#" } },
                                      [_vm._v(" Download ")]
                                    ),
                                    _c(
                                      "b-dropdown-item",
                                      { attrs: { href: "#" } },
                                      [_vm._v(" Delete ")]
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "b-modal",
                                  {
                                    attrs: {
                                      id: "modal-document",
                                      "ok-only": "",
                                      "ok-title": "Document",
                                      centered: "",
                                      size: "lg",
                                      title: "Document",
                                      "hide-footer": true,
                                    },
                                  },
                                  [
                                    _c("ViewDocument", {
                                      on: { refresh: _vm.refreshData },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c(
                              "b-card-body",
                              [
                                _c(
                                  "b-row",
                                  {
                                    staticClass:
                                      "justify-content-center align-items-center",
                                  },
                                  [
                                    _c(
                                      "b-col",
                                      {
                                        staticClass:
                                          "d-flex flex-column justify-content-center align-items-center text-center",
                                        attrs: { md: "6" },
                                      },
                                      [
                                        _c("feather-icon", {
                                          attrs: {
                                            icon: "FolderIcon",
                                            size: "50",
                                          },
                                        }),
                                        _c("b-card-text", [
                                          _vm._v("document2.pdf"),
                                        ]),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "b-button",
                  {
                    attrs: { size: "sm", variant: "outline-secondary" },
                    on: { click: row.toggleDetails },
                  },
                  [_vm._v(" Hide Details ")]
                ),
              ]
            },
          },
          {
            key: "cell(dateStarted)",
            fn: function (data) {
              return [
                _c("b-form-input", [_vm._v(" " + _vm._s(data.value) + " ")]),
              ]
            },
          },
          {
            key: "cell(expectedDate)",
            fn: function (data) {
              return [
                _c("b-form-input", [_vm._v(" " + _vm._s(data.value) + " ")]),
              ]
            },
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }